export const GET_MENU_DETAILS = 'providers/menuMaker/MenuDetails/GET_MENU_DETAILS';
export const EDIT_MENU = 'providers/menuMaker/MenuDetails/EDIT_MENU';
